import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const NAV_HEIGHT = 96; // px — height of sticky nav

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: "instant" });
      return;
    }
    // Hash present — poll until the target element is in the DOM, then scroll
    const id = hash.replace("#", "");
    const attempt = (tries = 0) => {
      const el = document.getElementById(id);
      if (el) {
        const top = el.getBoundingClientRect().top + window.scrollY - NAV_HEIGHT;
        window.scrollTo({ top, behavior: "smooth" });
      } else if (tries < 8) {
        setTimeout(() => attempt(tries + 1), 80);
      } else {
        window.scrollTo({ top: 0, behavior: "instant" });
      }
    };
    attempt();
  }, [pathname, hash]);

  return null;
}
